import { Typography, Box } from "@mui/material";
import { Product } from "../../types/Product";
import DOMPurify from 'dompurify';

interface ProductDescriptionProps {
  product: Product;
}

export default function ProductDescription({ product }: ProductDescriptionProps) {
  const sanitizedHtml = DOMPurify.sanitize(product.descripcionLarga || '');

  return (
    <Box>
      <Typography
        sx={{
          fontSize: "20px",
          fontFamily: "'Times New Roman', serif",
          lineHeight: 1.6,
          color: "#010101",
          '& p': {
            margin: '0.5em 0'
          },
          '& br': {
            display: 'block',
            content: '""',
            marginTop: '0.5em'
          }
        }}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    </Box>
  );
}














